import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { AdminContextService } from '../../context/admin-contex.service';
import { AdminService } from '../../services/admin.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-gestion-licencias',
    templateUrl: './gestion-licencias.component.html'
})
export class GestionLicenciasComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public licencias;
    public almacenes;

    public mensajes = new Array<Message>();
    public showError: boolean;

    public deleteModal = false;
    public disableModal = false;
    public newEditModal = false;
    public historyModal = false;
    public parametersModal = false;
    public refreshCheckbox_activada = false;
    public refreshCheckbox_habilitada = false;
    public refreshCheckboxesMode = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public licenciaId;
    public userName;
    public licenciaJunta;

    public toCloseSpinner = 0;

    public dropdownInfo: number;

    public disabledAlmacenes: Subject<boolean> = new Subject();

    public orderBy: string;
    public columnId: number;
    public indexOrder = 11;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminContext: AdminContextService,
        private readonly _adminService: AdminService,
        private readonly utilsService: UtilsService,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            pkc: [''],
            username: [''],
            etiquetador: [''],
            almacen: [{ value: '', disabled: true }],
            pais: [''],
            denominacion: [''],
            desVersionSwInicio: [''],
            desVersionSwFin: [''],
            activada: [''],
            habilitada: [''],
            modoEtiqueta: [''],
            modoCertificado: [''],
            fechaExpiracionInicio: [''],
            fechaExpiracionFin: [''],
            fechaUltUsoInicio: [''],
            fechaUltUsoFin: [''],
            fechaActualizadoInicio: [''],
            fechaActualizadoFin: [''],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false']
        });

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                let filters = {
                    etiquetadorId: etiquetador.id
                }
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._adminService.getAlmacenesByEtiquetador(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.almacenes = resp.lista;
                        this.disabledAlmacenes.next(false);
                        this.filtersForm.get('almacen').enable();
                    } else {
                        this.disabledAlmacenes.next(true);
                        this.filtersForm.get('almacen').disable();
                    }
                });
            } else {
                this.almacenes = null;
                this.disabledAlmacenes.next(true);
                this.filtersForm.get('almacen').disable();
                this.filtersForm.get('almacen').patchValue('');
            }
        });

        this._adminContext.gestionLicenciasFilters = null;
        this.indexOrder = this.role !== 'Etiquetador' ? this.indexOrder : 9;
        this.getLicencias();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadores;
    }

    public get denominaciones() {
        return this._dataProvider.denominaciones;
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get aplicacion() {
        return this._dataProvider.aplicacion;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public pageChange(page) {
        this._adminContext.gestionLicenciasFilters.numPagina = this.currentPage = page - 1;
        this.getLicencias();
    }

    public itemsPerPageChange(items) {
        this._adminContext.gestionLicenciasFilters.numPagina = this.currentPage = 0;
        this._adminContext.gestionLicenciasFilters.tamPagina = this.itemsPerPage = items;
        this.getLicencias();
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (
            this.filtersForm.get('pkc').value ||
            this.filtersForm.get('username').value ||
            this.filtersForm.get('etiquetador').value ||
            this.filtersForm.get('pais').value ||
            this.filtersForm.get('denominacion').value ||
            this.filtersForm.get('almacen').value ||
            this.filtersForm.get('desVersionSwInicio').value ||
            this.filtersForm.get('desVersionSwFin').value ||
            !this.filtersForm.get('activada').pristine ||
            !this.filtersForm.get('habilitada').pristine ||
            !this.filtersForm.get('modoEtiqueta').pristine ||
            !this.filtersForm.get('modoCertificado').pristine ||
            this.filtersForm.get('fechaExpiracionInicio').value ||
            this.filtersForm.get('fechaExpiracionFin').value ||
            this.filtersForm.get('fechaUltUsoInicio').value ||
            this.filtersForm.get('fechaUltUsoFin').value ||
            this.filtersForm.get('fechaActualizadoInicio').value ||
            this.filtersForm.get('fechaActualizadoFin').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value
        ) ? true : false;
    }

    public pristineCheckbox(idForm: string, pristine: boolean) {
        const form = this.filtersForm.get(idForm);
        pristine ? form.markAsPristine() : form.markAsDirty();
    }

    public filtrar() {
        this.validDates();
        
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    public resetForm() {
        this.filtersForm.reset();
        this.filtersForm.get('dateType').patchValue('false');
        this.refreshCheckbox_activada = true;
        this.refreshCheckbox_habilitada = true;
        this.refreshCheckboxesMode = true;
    }

    public applyFilters() {
        this.currentPage = 0;
        this._adminContext.gestionLicenciasFilters = {
            pkc: this.filtersForm.get('pkc').value ? this.filtersForm.get('pkc').value : '',
            userName: this.filtersForm.get('username').value ? this.filtersForm.get('username').value : '',
            etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : '',
            almacenId: this.filtersForm.get('almacen').value ? this.filtersForm.get('almacen').value.id : '',
            paisId_Almacen: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : '',
            denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : '',
            tipoSwId: 1,
            desVersionSwInicio: this.filtersForm.get('desVersionSwInicio').value ? this.filtersForm.get('desVersionSwInicio').value : '',
            desVersionSwFin: this.filtersForm.get('desVersionSwFin').value ? this.filtersForm.get('desVersionSwFin').value : '',
            activada: this.filtersForm.get('activada').value ? this.filtersForm.get('activada').value : '',
            habilitada: this.filtersForm.get('habilitada').value ? this.filtersForm.get('habilitada').value : '',
            modoCertificado: this.filtersForm.get('modoCertificado').value ? this.filtersForm.get('modoCertificado').value : '',
            modoEtiqueta: this.filtersForm.get('modoEtiqueta').value ? this.filtersForm.get('modoEtiqueta').value : '',
            fechaExpiracionInicio: this.filtersForm.get('fechaExpiracionInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaExpiracionInicio').value) : '',
            fechaExpiracionFin: this.filtersForm.get('fechaExpiracionFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaExpiracionFin').value) : '',
            fechaUltUsoInicio: this.filtersForm.get('fechaUltUsoInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaUltUsoInicio').value) : '',
            fechaUltUsoFin: this.filtersForm.get('fechaUltUsoFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaUltUsoFin').value) : '',
            fechaActualizadoInicio: this.filtersForm.get('fechaActualizadoInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaActualizadoInicio').value) : '',
            fechaActualizadoFin: this.filtersForm.get('fechaActualizadoFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaActualizadoFin').value) : '',
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            cargaRegistroEnUso: true,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this.getLicencias();
    }

    public getLicencias() {
        if (this._adminContext.gestionLicenciasFilters) {
            this._filters = this._adminContext.gestionLicenciasFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.getLicencias(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.licencias = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public openHistory(licencia) {
        this.licenciaId = licencia.id;
        this.userName = licencia.userName;
        this.historyModal = true;
    }

    public openParameters(licencia) {
        this.licenciaId = licencia.id;
        this.userName = licencia.userName;
        this.licenciaJunta = licencia.licenciaEtiquetadorJunta;
        this.parametersModal = true;
    }

    public create() {
        this.licenciaId = null;
        this.newEditModal = true;
    }

    public disableLicense() {
        let licenciaSw = {
            licenciaSwId: this.licenciaId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.desactivarLicencia(licenciaSw).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemUpdated');
            this.getLicencias();
        }, (error) => {
            this.showError = true;
            switch (error.error.ApiErrorCode) {
                case 6187:
                    this.mensajes.push({ class: 'error', message: 'gestionLicencias.errores.licenciaDesactivada' });
                    break;
                case 6188:
                    this.mensajes.push({ class: 'error', message: 'gestionLicencias.errores.licenciaDeshabilitada' });
                    break;
                default:
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                    break;
            }
        });
    }

    public askDisable(licencia) {
        this.licenciaId = licencia.id;
        this.disableModal = true;
    }

    public update(licencia) {
        this.licenciaId = licencia.id;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.deleteLicencia(this.licenciaId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getLicencias();
        });
    }

    public askDelete(licencia) {
        this.licenciaId = licencia.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
        this.historyModal = false;
        this.parametersModal = false;
        this.disableModal = false;
    }

    public refresh(value) {
        this.historyModal = false;
        this.newEditModal = false;
        this.parametersModal = false;
        if (value) {
            this.getLicencias();
        }
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máximo que en table.scss)
        if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro panel abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        this.mensajes.push({ class: 'success', message: mensaje });
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public copyPKC(licencia: any) {
        if (!navigator.clipboard) {
            // use old commandExec() way
        } else {
            navigator.clipboard.writeText(licencia.pkc).then(() => {
                this.pushMessage('gestionRoyalties.portapapeles.pkcCopiado');
            });
        }
    }

    public copyUserName(licencia: any) {

        if (!navigator.clipboard) {
            // use old commandExec() way
        } else {
            navigator.clipboard.writeText(licencia.userName).then(() => {
                this.pushMessage('gestionRoyalties.portapapeles.usuarioCopiado');
            });
        }
    }

    public getIcon(prop: string) {
        let iconClass = 'fa fa-sort';
        if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
            iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
        }
        return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
        this.columnId = idColumn;
        if (this.licencias && this.licencias.length > 0) {
            if (this._adminContext.gestionLicenciasFilters) {
                this._filters = this._adminContext.gestionLicenciasFilters;
                if (!this.orderBy || this.orderBy.includes('DESC')) {
                    this.orderBy = 'ASC' + idColumn;
                    this._filters.orderItems = [
                        {
                            orderProperty: columnFilter,
                            orderByDescending: false
                        }
                    ];
                } else if (this.orderBy.includes('ASC')) {
                    this.orderBy = 'DESC' + idColumn;
                    this._filters.orderItems = [
                        {
                            orderProperty: columnFilter,
                            orderByDescending: true
                        }
                    ];
                }
                this.getLicencias();
            }
        }
    }

    public openDocHelp() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.getDocHelp('Administration_Licenses.pdf').toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            localStorage.setItem('base64', resp.base64Archivo);
            const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
            window.open(url, '_blank');
        });
    }

    public trackByLicenciaId(index: number, licencia: { id: number }): number {
        return licencia.id;
    }
}
